<template>
    <div class="news" id="news">
        <div class="mobiletopbox hidden-sm-and-up">
            <div class="mobiletopbox_top">
                <div class="navigation">
                    <div class="navigation_location"></div>
                    <div class="navigation_index" @click="goIndex">首页</div>
                    <div class="navigation_img"></div>
                    <div class="navigation_text">{{typeName}}</div>
                    <div class="navigation_img" v-if="categoryName"></div>
                    <div class="navigation_text" v-if="categoryName">{{categoryName}}</div>
                    <div class="navigation_img"></div>
                    <div class="navigation_text">详情</div>
                </div>
            </div>
            <div class="mobiletopbox_bottom" :class="isShowType?'mobiletopbox_bottom_active':''">
                <div class="mobile_type section">
                    <div class="mobile_type_text">
                        <div class="mobile_type_text_left" @click="handleShowType">分类</div>
                        <div class="mobile_type_text_right">
                            <img src="../assets/images/common/more.png" alt="">
                        </div>
                    </div>
                    <div class="mobile_type_box" v-if="isShowType">
                        <div class="mobile_type_box_item" 
                           @click="handleChangeType(item.id)"
                           :class="query.newsType==item.id?'mobile_type_box_item_active':''"
                           v-for="(item,i) in typeList" :key="i">
                           <div class="mobile_type_box_item_left"></div>
                           <div class="mobile_type_box_item_right">{{item.typeName}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="news_top section hidden-xs-only">
            <div class="navigation">
                <div class="navigation_location"></div>
                <div class="navigation_text">当前所在位置：</div>
                <div class="navigation_index" @click="goIndex">首页</div>
                <div class="navigation_img"></div>
                <div class="navigation_text">{{typeName}}</div>
                <div class="navigation_img" v-if="categoryName"></div>
                <div class="navigation_text" v-if="categoryName">{{categoryName}}</div>
                <div class="navigation_img"></div>
                <div class="navigation_text">详情</div>
            </div>
        </div>
        <div class="news_box section">
            <div class="news_left hidden-xs-only">
                <div class="news_left_top">
                    <div class="news_left_top_left">{{typeName}}</div>
                    <div class="news_left_top_right">
                        <img src="../assets/images/conference/menu.png" alt="">
                    </div>
                </div>
                <div class="news_left_box" v-if="typeList.length>0">
                    <div class="news_left_item"
                    @click="handleChangeType(item.id)"
                    :class="query.newsType==item.id?'news_left_item_active':''"
                    v-for="(item,i) in typeList" :key="i">
                        <div class="news_left_item_left">{{item.typeName}}</div>
                        <div class="news_left_item_right">
                            <img v-if="query.newsType==item.id" src="../assets/images/news/rightArrow_active.png" alt="">
                            <img v-else src="../assets/images/news/rightArrow.png" alt="">
                        </div>
                        <div class="news_left_item_line">
                            <img v-if="query.newsType==item.id" src="../assets/images/news/line_active.png" alt="">
                            <img v-else src="../assets/images/news/line_none.png" alt="">
                        </div>
                    </div>
                </div>
                <div class="news_left_box_none" v-else></div>
            </div>
            <div class="news_right" v-loading="loading">
                <!-- 详情 -->
                <div class="news_right_bottom">
                    <div class="news_right_bottom_box">
                        <div class="details_content">
                            <div class="details_title">
                                <div class="details_title_top">{{ detailsContent.title }}</div>
                                <div class="details_title_bottom">
                                    <div class="details_title_bottom_left">
                                        发布时间：
                                        <span>{{detailsContent.publishTime?handleTime(detailsContent.publishTime):""}}</span>
                                    </div>
                                    <div class="details_title_bottom_line"></div>
                                    <div class="details_title_bottom_right">
                                        浏览量：{{detailsContent.browseCount?detailsContent.browseCount:0}}
                                        <span></span>
                                    </div>
                                </div>
                            </div>
                            <div class="common_artical" v-if="detailsContent.content">
                                <div v-html="detailsContent.content"></div>
                            </div>
                            <div class="file" v-if="detailsContent.newsFileList && detailsContent.newsFileList.length > 0">
                                <div class="file_box">
                                    <div class="file_left">附加文件：</div>
                                    <div class="file_right">
                                        <div class="file_right_item" v-for="(item, i) in detailsContent.newsFileList" :key="i">
                                            <a :href="baseUrl + item.fileUrl">{{ item.fileName }}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="details_content_other">
                            <div class="details_content_other_left">
                                <div class="details_content_other_left_item" style="margin-bottom:20px;">
                                    上一篇：
                                    <span v-if="prevDetail&&prevDetail.title" @click="handlePrev(prevDetail)">{{prevDetail.title}}</span>
                                </div>
                                <div class="details_content_other_left_item">
                                    下一篇：
                                    <span v-if="nextDetail&&nextDetail.title" @click="handlePrev(nextDetail)">{{nextDetail.title}}</span>
                                </div>
                            </div>
                            <div class="details_content_other_right" @click="goBack">
                                <div class="details_content_other_right_img">
                                    <img src="../assets/images/common/back_list.png" alt="">
                                </div>
                                <div class="details_content_other_right_text">返回列表</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { newsTypeList, newsList,newsDetails,newsBrowse } from '../untils/common-api.js'
import { menu } from "../untils/menu"
export default {
    data() {
        return {
            menuList:menu,
            baseUrl: process.env.VUE_APP_BASE_URL,
            loading: false,
            typeId: this.$route.params.type,
            typeName:'',
            id: this.$route.params.id,
            name:this.$route.params.name,
            showType:null,//1为单列,2为多列，3为详情
            categoryName:'',
            typeList: [],
            current:this.$route.params.current,
            query: {
                current: 1,
                pageSize: -1,
                newsType: this.$route.params.category?this.$route.params.category:'',
                model:this.$route.params.type?this.$route.params.type:'',
                lang:1,
            },
            newsList: [],
            detailsContent: '',
            prevDetail:{},
            nextDetail:{},

            isShowType:false

        }
    },
    created() {
        if(this.name=='allice') {
            this.query.model = 109
            this.typeName = '联系联盟'
            this.typeList = [
                {
                    id:0,
                    typeName:'联系联盟'
                }
            ]
            this.getNewsList()
        } else {
            this.getTypeName()
            this.getNewsType()
            this.getDetails(this.id)
        }
    },
    mounted() {
        this.getScrollTop()
    },
    methods:{
        getTypeName() {
            let item = this.menuList.find(item => item.id == this.typeId)
            if(item) {
                this.typeName = item.name
            }
        },
        async getNewsType() {
            let res = await newsTypeList(
                {
                    model:this.typeId,
                    lang:1,
                }
            )
            if (res.code !== 1) return this.$message('信息获取失败，请稍后重试')
            this.typeList = res.data.records
            if(this.typeList.length > 0) {
                if(this.query.newsType) {
                    this.showType = this.typeList.find(item => item.id == this.query.newsType).showType
                    this.categoryName = this.typeList.find(item => item.id == this.query.newsType).typeName
                }
            }
            this.getNewsList()
        },
        // 获取新闻列表
        async getNewsList() {
            let res = await newsList(this.query)
            if (res.code !== 1) return this.$message('信息获取失败，请稍后重试')
            this.newsList = res.data.records
            if(this.name=='allice') {
                this.id = this.newsList[0].id
                this.getDetails(this.id)
            }
            this.getOtherDetail()

        },
        getOtherDetail() {
            if(this.newsList.length>0) {
                // 通过id在列表中查找当前文章的索引
                let index = this.newsList.findIndex(item => item.id == this.id)
                // 如果索引为0，说明当前文章为第一篇，没有上一篇
                if (index == 0) {
                    this.prevDetail = {}
                } else {
                    this.prevDetail = this.newsList[index - 1]
                }
                // 如果索引为列表长度减1，说明当前文章为最后一篇，没有下一篇
                if (index == this.newsList.length - 1) {
                    this.nextDetail = {}
                } else {
                    this.nextDetail = this.newsList[index + 1]
                }
            }
        },
        handlePrev(item) {
            this.id = item.id
            this.getDetails(item.id)
            this.getOtherDetail()
            this.getScroll()
        },
        async getDetails(id) {
            this.loading = true // loading start
            let res = await newsDetails(id)
            this.loading = false // loading end
            if (res.code !== 1) return this.$message('信息获取失败，请稍后重试')
            this.detailsContent = res.data
            this.getNewsBrowse(id)
        },
        async getNewsBrowse(id) {
            const res = await newsBrowse(id)
            if (res.code !== 1) return this.$message('信息获取失败，请稍后重试')
        },
        // 更改类型
        handleChangeType(id) {
            if(this.name=='allice') {
                return
            } else {
                window.location.href = '/#/conference/list/'+this.typeId+'/' + id+'/1'
                window.sessionStorage.setItem('scrollPosition', 0);
            }
        },
        goIndex() {
            this.$router.push('/conference/index')
        },
        handleTime(time) {
            if(time) {
                let year = time.substring(0,4);
                let month = time.substring(5,7);
                let day = time.substring(8,10);
                let timeStr = year+'-'+month+'-'+day
                return timeStr;
            }
        },
        getScroll() {
            let div = document.getElementById('news');
            if (div) {
                setTimeout(function () {
                    $('html, body').animate({scrollTop: 0}, 600)
                }, 500);
            }
        },
        getScrollTop() {
            let div = document.getElementById('news');
            if (div) {
                setTimeout(function () {
                    $('html, body').animate({scrollTop: 0}, 0)
                }, 0);
            }
        },
        goBack() {
            if(this.name=='allice') {
                this.goIndex()
            } else {
                const scrollPosition = window.sessionStorage.getItem('scrollPosition');
                if (scrollPosition == '-1') {
                    window.sessionStorage.setItem('scrollPosition', 0);
                }
                window.location.href = '/#/conference/list/'+this.typeId+'/'+this.query.newsType+'/'+this.current
            }
        },
        handleShowType() {
            this.isShowType = !this.isShowType
        }
    },
    beforeRouteLeave(to, from, next) {
        if(to.name != "confernece_list") {
            window.sessionStorage.removeItem('scrollPosition'); 
        }
        next();
    },
}
</script>
<style lang="less" scoped>
.news {
    background-color: #f6f9ff;
    padding: 20px 0 60px 0;
    .news_top {
        margin-bottom: 20px;
        border-radius: 12px;
    }
    .news_box {
        display: flex;
        .news_left {
            width: 288px;
            margin-right: 30px;
            .news_left_top {
                width: 100%;
                height: 82px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                background: linear-gradient(to bottom right, #1895dd, #0085d0);
                border-radius: 12px 12px 0px 0px;
                padding: 0 30px;
                .news_left_top_left {
                    font-size: 28px;
                    color: #ffffff;
                }
                .news_left_top_right {
                    width: 28px;
                    height: 28px;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
            }
            .news_left_box {
                padding: 24px 20px 20px 20px;
                background-color: #ffffff;
                border-radius:0px 0px 12px 12px ;
                .news_left_item {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    font-size: 18px;
                    padding: 0 20px 0 25px;
                    background-color: #F6F9FF;
                    margin-bottom: 10px;
                    height: 56px;
                    cursor: pointer;
                    position: relative;
                    border-radius: 6px;
                    .news_left_item_right {
                        img {
                            width: 12px;
                            height: 12px;
                        }
                    }
                    .news_left_item_line {
                        position: absolute;
                        top: 50%;
                        transform: translateY(-50%);
                        left: 0;
                        width: 6px;
                        height: 24px;
                        img {
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 6px;
                            height: 24px;
                        }
                    }
                }
                .news_left_item_active {
                    background-color: #0085D0;
                    color: #ffffff;
                }
                .news_left_item:last-child {
                    margin-bottom: 0;
                }
            }
            .news_left_box_none {
                // border-radius:0px 0px 12px 12px ;
                // background-color: #ffffff;
                // display: flex;
                // justify-content: center;
                // align-items: center;
                // min-height: 100px;
                // font-size: 16px;
            }
        }
        .news_right {
            width: calc(100% - 288px - 30px);
            .news_right_bottom {
                background-color: #ffffff;
                border-radius: 12px;
                .news_right_bottom_box {
                    padding: 30px;
                    .details_content {
                        .details_title {
                            padding-bottom: 25px;
                            border-bottom: 1px solid #EBEFF6;
                            .details_title_top {
                                font-size: 24px;
                                line-height: 36px;
                                font-weight: bold;
                                text-align: center;
                                margin-bottom: 20px;
                            }
                            .details_title_bottom {
                                font-size: 16px;
                                color: #787878;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                .details_title_bottom_left {
                                    span {
                                        color: #000000;
                                    }
                                }
                                .details_title_bottom_line {
                                    width: 1px;
                                    height: 15px;
                                    background-color: #000000;
                                    margin: 0 20px;
                                }
                                .details_title_bottom_right {
                                    span {
                                        color: #000000;
                                    }
                                }
                            }
                        }
                        .common_artical {
                            padding: 25px 0;
                            border-bottom: 1px solid #EBEFF6;
                        }
                        .file {
                            padding: 25px 0;
                            border-bottom: 1px solid #EBEFF6;
                            .file_box {
                                display: flex;
                                .file_left {
                                    width: 80px;
                                    font-size: 16px;
                                }
                                .file_right {
                                    width: calc(100% - 80px);
                                    .file_right_item {
                                        margin-bottom: 5px;
                                        a {
                                            font-size: 16px;
                                        }
                                    }
                                    .file_right_item:last-child {
                                        margin-bottom: 0;
                                    }
                                }
                            }
                        }
                    }
                    .details_content_other {
                        margin-top: 30px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        .details_content_other_left {
                            width: calc(100% - 118px - 32px);
                            font-size: 16px;
                            color: #4B4B4B;
                            .details_content_other_left_item {
                                display: -webkit-box;
                                -webkit-line-clamp: 1;
                                -webkit-box-orient: vertical;
                                overflow: hidden;
                                span {
                                    cursor: pointer;
                                }
                            }
                        }
                        .details_content_other_right {
                            width: 118px;
                            height: 72px;
                            background: #2277ec;
                            display: flex;
                            justify-content: center;
                            flex-direction: column;
                            align-items: center;
                            border-radius: 36px;
                            cursor: pointer;
                            .details_content_other_right_img {
                                img {
                                    width: 35px;
                                    height: 35px;
                                }
                            }
                            .details_content_other_right_text {
                                font-size: 16px;
                                color: #ffffff;
                            }
                        }
                    }
                }
            }
        }
    }
}
@media (max-width: 768px) {
    .news {
        padding: .3rem 0 .6rem 0;
        .news_box {
            flex-direction: column;
            .news_right {
                width: 100%;
                padding-top: 0.2rem;
                .news_right_bottom {
                    background-color: #ffffff;
                    .news_right_bottom_box {
                        padding: 0.3rem 0.2rem;
                        .details_content {
                            .details_title {
                                padding-bottom: 0.3rem;
                                .details_title_top {
                                    font-size: 0.35rem;
                                    line-height: 1.5;
                                    margin-bottom: .2rem;
                                }
                                .details_title_bottom {
                                    font-size: 0.26rem;
                                    .details_title_bottom_line {
                                        width: 0.02rem;
                                        height: 0.28rem;
                                        margin: 0 0.2rem;
                                    }
                                }
                            }
                            .common_artical {
                                padding: 0.3rem 0;
                            }
                            .file {
                                padding: 0.3rem 0;
                                .file_box {
                                    .file_left {
                                        width: 1.4rem;
                                        font-size: 0.28rem;
                                    }
                                    .file_right {
                                        width: calc(100% - 1.4rem);
                                        .file_right_item {
                                            margin-bottom: 0.1rem;
                                            a {
                                                font-size: 0.28rem;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        .details_content_other {
                            margin-top: .3rem;
                            .details_content_other_left {
                                width: calc(100% - 1.7rem - 0.2rem);
                                font-size: 0.28rem;
                                .details_content_other_left_item:first-child {
                                    margin-bottom: 0.15rem;
                                }
                            }
                            .details_content_other_right {
                                width: 1.7rem;
                                height: 1.1rem;
                                border-radius: 0.55rem;
                                .details_content_other_right_img {
                                    img {
                                        width: 0.5rem;
                                        height: 0.5rem;
                                    }
                                }
                                .details_content_other_right_text {
                                    font-size: 0.26rem;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

</style>